// Golf 4 (Turks): Jouw gegevens (0036), weergave per tablet, wijzigingen weggooien,
// verwachte dagen, modules, werklijst en Ramadan op het bord. Zelfde vorm als de nl-bestanden; de
// stukken worden in app.tr.ts, profileApp.tr.ts, modulesApp.tr.ts, werklijstApp.tr.ts en
// weatherPrayer.tr.ts ingehaakt. AMUMIN Beheer (beheerApp) blijft nl/en: alleen de oprichter.
export const appPrivacyRightsTr = {
    title: 'Verileriniz',
    intro: 'Her şeyi indirin, aileden birini çıkarın veya aile panosunu silin. Bunlar sizin verileriniz.',
    entry: 'Verileriniz',
    entryBody: 'Her şeyi indirin, aileden birini çıkarın, aile panosunu silin.',
    exportTitle: 'Her şeyi indir',
    exportBody: 'Ailenizle ilgili her şeyi içeren tek bir ZIP dosyası: üyeler, takvim, görevler, yemek, mesajlar, fotoğraflarla ilgili bilgiler ve Ailemize uyan bölümündeki seçimler. Yanında okunabilir bir özet de var.',
    exportOwnerOnly: 'Her şeyi yalnızca aile panosunun sahibi indirebilir.',
    exportStart: 'İndirmeyi hazırla',
    exportPending: 'Dosyayı hazırlıyoruz. Bu genellikle bir dakikadan kısa sürer.',
    exportReady: 'Hazır · {size} · {time} saatine kadar indirilebilir',
    exportOnce: 'Dosyayı bir kez indirebilirsiniz. Sonra onu sileriz.',
    exportDownload: 'İndir',
    exportDownloaded: '{time} tarihinde indirildi',
    exportExpired: '{time} tarihinde süresi doldu',
    exportFailed: 'Dosya oluşturulamadı. Tekrar deneyin.',
    exportAgain: 'Yeniden hazırla',
    exportMailed: 'Tüm ebeveynlere indirmenin hazır olduğunu bildiren bir e-posta gider.',
    exportStarted: 'Dosyayı hazırlıyoruz',
    exportSaved: 'Dosya indirilenler klasörünüzde',
    mineTitle: 'Yalnızca kendi verileriniz',
    mineBody: 'Kendi verileriniz ve sizin için geçerli aile profili, dosya olarak (JSON).',
    mineButton: 'Verilerimi indir',
    removeTitle: 'Aileden birini çıkar',
    removeBody: 'Örneğin evden ayrılan bir çocuk veya eski bir eş. Bunu Aile bölümünde yaparsınız: kişiyi açın ve Aileden çıkar’ı seçin.',
    removeToMembers: 'Aile’ye git',
    removeButton: 'Aileden çıkar',
    removeConfirmTitle: '{name} aileden çıkarılsın mı?',
    removeConfirmNow: '{name} uygulamadan ve panodan hemen kaybolur. {name} kendi girişine sahipse, bu giriş bu aile için artık çalışmaz.',
    removeConfirmLater: 'Bunu 7 gün içinde geri alabilirsiniz. Sonra {name} anonim hale gelir: adı “Eski aile üyesi” olur, fotoğraf, doğum tarihi ve özel veriler (inanç, sağlık, okul) silinir, gelecekteki randevular ve görevler de. Olmuş olanlar isimsiz olarak kalır.',
    removeConfirmProfile: 'Ailemize uyan ve hava durumu bölümündeki kişisel seçimler hemen silinir ve geri alındığında geri gelmez.',
    removeConfirmButton: 'Aileden çıkar',
    removeButtonHouse: 'Evden çıkar',
    removeConfirmTitleHouse: '{name} evden çıkarılsın mı?',
    removeConfirmNowHouse: '{name} uygulamadan ve panodan hemen kaybolur. {name} için kendi girişi varsa, bu ev için artık çalışmaz.',
    removeConfirmLaterHouse: 'Bunu 7 gün içinde geri alabilirsin. Sonra {name} anonim yapılır: ad “{former}” olur, fotoğraf ve kişisel bilgiler silinir, gelecekteki etkinlikler ve görevler de. Olmuş olanlar (harcamalar dahil) adsız kalır.',
    removeConfirmProfileHouse: '{name} için yapılan kendi seçimler (yemek ve hava gibi) hemen silinir ve geri alındığında geri gelmez.',
    removeConfirmButtonHouse: 'Evden çıkar',
    removeConfirmAnywayHouse: 'Yine de evden çıkar',
    removedHouse: '{name} evden çıkarıldı',
    removeConfirmLinks: '{name} tarafından oluşturulan takvim bağlantıları (Google, Outlook veya Apple Takvim) hemen durur.',
    removeConfirmDevices: '{name} bu tabletleri bağladı. Bağlantısını kaldırana kadar çalışmaya devam ederler:',
    removeUnpairDevice: 'Tabletin bağlantısını kaldır',
    removeDevicePaired: '{date} tarihinde bağlandı',
    removeDeviceUnpaired: '{name} bağlantısı kaldırıldı',
    removed: '{name} aileden çıkarıldı',
    removedListTitle: 'Aileden çıkarılanlar',
    removedUntil: '{time} tarihine kadar geri alınabilir',
    removedHadLogin: 'Giriş iptal edildi',
    undo: 'Geri al',
    undone: '{name} aileye geri döndü',
    undoneNoLogin: '{name} aileye geri döndü. Giriş geri alınamadı; yeniden davet edin.',
    errorIsOwner: 'Sahip aileden çıkarılamaz.',
    errorIsSelf: 'Kendinizi aileden çıkaramazsınız.',
    errorNeedsOwner: 'Başka bir ebeveyni yalnızca sahip aileden çıkarabilir.',
    errorWindowClosed: '7 gün geçti; artık geri alınamaz.',
    errorAlreadyRemoved: 'Bu kişi zaten aileden çıkarıldı.',
    errorDeletionUnavailable: 'Silme şu anda mümkün değil. Hiçbir şey planlanmadı; daha sonra tekrar dene veya bize e-posta gönder.',
    errorConfirmName: 'Ad eşleşmiyor. Aile panonuzun adını tam olarak yazın.',
    errorExportGone: 'Bu dosya artık yok. Yeni bir indirme hazırlayın.',
    zipHint: 'Her şey okunabilir bir özetle tek bir ZIP olarak:',
    deleteTitle: 'Aile panosunu sil',
    deleteBody: 'Ailenizle ilgili her şey silinir: takvim, görevler, yemek, mesajlar, fotoğraflar ve ayarlar. 30 gün düşünme süreniz var.',
    deleteOwnerOnly: 'Aile panosunu yalnızca sahibi silebilir.',
    deleteButton: 'Aile panosunu sil…',
    deleteConfirmTitle: 'Aile panosu silinsin mi?',
    deletePoints: [
        '30 gün sonra {household} ile ilgili her şeyi sileriz. Bu daha sonra geri alınamaz.',
        'O güne kadar Silme, vazgeçtim ile durdurabilirsiniz.',
        'Tabletler o zamana kadar sakin bir bildirim gösterir ve sonra durur.',
        'Tüm ebeveynler şimdi ve her şey silindiğinde bir e-posta alır.',
    ],
    deleteExportFirst: 'Önce her şeyi indirmek ister misiniz?',
    deleteExportFirstBody: 'Silmeden önce bir kopya alın. Bu, o güne kadar daha sonra da mümkün.',
    deleteTypeName: 'Onaylamak için aile panonuzun adını yazın',
    deleteTypeNameHint: 'Tam olarak: {household}',
    deleteConfirmButton: '30 gün sonra sil',
    deleteScheduled: 'Aile panosu {date} tarihinde silinecek',
    deleteScheduledBody: 'O güne kadar her şey normal çalışır. Sonra her şeyi sileriz ve tüm ebeveynler bir e-posta alır.',
    deleteScheduledByAdmin: 'Sizin isteğiniz üzerine AMUMIN tarafından planlandı.',
    cancelDelete: 'Silme, vazgeçtim',
    cancelled: 'Aile panosu kalıyor',
    banner: 'Bu aile panosu {date} tarihinde silinecek.',
    bannerOwner: 'Silme, vazgeçtim',
    bannerOthers: 'Bunu yalnızca sahip durdurabilir.',
    bannerMore: 'Daha fazla bilgi',
    formerMember: 'Eski aile üyesi',
    formerMemberShared: 'Eski ev arkadaşı',
    formerMemberResident: 'Eski sakin',
    summary: {
        title: '{household} verileri',
        intro: 'Bunlar, AMUMIN’in sakladığı haliyle aile panonuzun {date} tarihindeki tüm verileridir. Her bölüm kendi JSON dosyasında; bunu bir metin düzenleyiciyle açabilir veya başka bir programa aktarabilirsiniz.',
        fileHeader: 'Dosya',
        whatHeader: 'İçinde ne var',
        countHeader: 'Satır',
        membersTitle: 'Üyeler',
        memberFormer: 'eski aile üyesi',
        memberArchived: 'artık aktif değil',
        notIncludedTitle: 'İçinde olmayanlar',
        notIncluded: 'Gizli bilgiler (şifreler, PIN kodları, eşleştirme kodları ve tabletlerin giriş bilgileri), teknik kayıtlar ve diğer hizmetlerin yanıtlarının geçici kopyaları. Fotoğrafların ve kayıtların kendisi içinde yok; ne zaman çekildikleri ve boyutları var.',
        rightsTitle: 'Haklarınız',
        rights: 'Verileri uygulamanın kendisinde düzeltebilir, aileden birini çıkarabilir veya tüm aile panosunu Ayarlar › Verileriniz bölümünden silebilirsiniz. Sorunuz veya şikâyetiniz mi var? AMUMIN ile iletişime geçin (uygulamadaki gizlilik bildirimine bakın); Hollanda Veri Koruma Kurumu’na (Autoriteit Persoonsgegevens) da şikâyette bulunabilirsiniz.',
        accountTitle: 'Hesabınız',
        accountBody: 'Giriş yaptığınız e-posta adresi ve hesabınızın ne zaman oluşturulduğu (account.json).',
        domains: {
            household: {
                title: 'Aile ve tabletler',
                body: 'Hane türüyle aile panosu, üyeler, girişler (şifreler olmadan) ve ekran seçimleri, odalar, tabletler, davetler ve yaklaşık konum.',
            },
            profile: {
                title: 'Ailemize uyan',
                body: 'Mutfak, inanç, yemek ve özel günler, tüm onaylarla birlikte (geri çekilenler dahil).',
            },
            calendar: {
                title: 'Takvim',
                body: 'Randevular, tekrarlar, kimin katıldığı, ulaşım, hatırlatmalar ve bağlı takvimler.',
            },
            tasks: {
                title: 'Görevler ve ödüller',
                body: 'Görevler, kimin yaptığı, puanlar, ödüller ve talepler.',
            },
            food: {
                title: 'Yemek',
                body: 'Alışveriş, tarifler, haftalık menü ve kiler.',
            },
            // Golf 8 (0049): Kosten delen.
            costs: {
                title: 'Masrafları paylaş',
                body: 'Paylaşımıyla birlikte masraflar, hesaplaşmalar ve evin kapanan dönemleri.',
            },
            family: {
                title: 'Aile ve mesajlar',
                body: 'Dilek listeleri, kişiler, bağlı aileler, sohbetler ve mesajlar.',
            },
            rooms: {
                title: 'Odalar ve temizlik',
                body: 'Kimin hangi odada uyuduğu, işler, nöbet çizelgesi (yokluklar ve değişimler), temizlik kaydı ve çocuk kilitleri (kod olmadan).',
            },
            media: {
                title: 'Fotoğraflar ve kayıtlar',
                body: 'Fotoğraflar ve kayıtlarla ilgili bilgiler: tür, boyut ve tarih.',
            },
            care: {
                title: 'Kontrol ve aile çemberi',
                body: "'Her şey yolunda'ya ne zaman dokunulduğu, haberler ve kimin aldığı, duraklatmalar, hakları ile çember ve yaşlı kişinin onayları.",
            },
            weather_prayer: {
                title: 'Hava durumu ve namaz vakitleri',
                body: 'Hava durumu önerisi ve namaz vakitleri ayarları.',
            },
            growth: {
                title: 'Büyüme',
                body: 'Kullanıyorsanız, onaylarla birlikte boy ve kilo.',
            },
            school: {
                title: 'Okul',
                body: 'Kullanıyorsanız, dersler ve sonuçlar.',
            },
            security: {
                title: 'Güvenlik',
                body: 'Güvenilir ağlar, güvenlik bildirimleri ve denetim kaydı (kim ne yaptı, içerik olmadan).',
            },
            privacy: {
                title: 'Gizlilik talepleri',
                body: 'Bunun gibi indirmeler, aileden kimin çıkarıldığı ve planlanmış bir silme.',
            },
            billing: {
                title: 'Abonelik ve faturalar',
                body: 'Aboneliğin ve deneme ayın, neyin değiştiği (iptal, ödeme) ve faturalar. Faturaları silme sonrasında da 7 yıl saklarız (yasal zorunluluk).',
            },
            // 0068: Gezond op gewicht (persoonlijk).
            kompas: {
                title: 'Sağlıklı kilo',
                body: 'Yalnızca senin: iznin, profilin ve hedefin, ne yediğin, su, hareket, tartılmalar ve panodaki kutucuğun. Kendi alanında durur; başka kimse görmez.',
            },
            // 0069: Geldzaken.
            money: {
                title: 'Para işleri',
                body: 'Kendi alanların, işlemlerin (başkasının IBAN’ı gizlenmiş), kuralların, hedeflerin ve varlıkların. Yalnızca kendi alanının indirmesinde.',
            },
        },
    },
};
export const appEditorG4Tr = {
    discardTitle: 'Değişiklikler silinsin mi?',
    discardBody: 'Doldurduklarınız o zaman kaybolur.',
    discardKeep: 'Düzenlemeye devam et',
    discardConfirm: 'Sil',
};
export const appDevicesG4Tr = {
    layout: 'Görünüm',
    layoutAuto: 'Otomatik',
    layoutAutoHint: 'Tablet döndürülse bile ekrana kendiliğinden uyar: küçük ekranda kompakt, yatay büyük ekranda geniş, diğer durumlarda büyük.',
    layoutLarge: 'Büyük',
    layoutLargeHint: 'Tüm pano yan yana, oturma odasındaki iPad’deki gibi.',
    layoutCompact: 'Kompakt',
    layoutCompactHint: 'Daha az yan yana ve her şey daha büyük, 2 metreden okunur. Küçük bir tablet veya iPad mini için.',
    layoutShown: 'Görünüm: {layout}',
    // Tablet-breed: breed (en automatisch op elk scherm).
    layoutWide: 'Geniş',
    layoutWideHint: 'Takvim, görevler ve Bugün sütunu yan yana. Yatay asılan 10 inç veya daha büyük bir tablet için.',
};
export const appProfileDaysG4Tr = {
    expectedTag: 'beklenen',
    sheet: {
        expected: 'Bu gün henüz kesin değil.',
        when: '{dates} tarihine denk geliyor.',
        confirm: 'Günü onayla',
        confirmHint: 'Ailemize uyan, Özel günler bölümünde onaylayın veya kaydırın.',
    },
};
export const appModulesG4Tr = {
    offBecause: 'Kapalı ({names} kapalı)',
    exampleA: 'Elif',
    exampleB: 'Emre',
    holidaysIslamic: 'Ramazan Bayramı ve Kurban Bayramı da geleneğinize göre.',
};
export const appWerklijstG4Tr = {
    progressRegion: 'İlerleme',
};
export const prayerRamadanTr = {
    word: {
        turkish: 'Ramazan',
        arabic: 'Ramazan',
    },
    imsak: {
        turkish: 'İmsak',
        arabic: 'İmsak',
    },
    sabah: {
        turkish: 'Sabah',
        arabic: 'Sabah',
    },
    iftar: {
        turkish: 'İftar',
        arabic: 'İftar',
    },
    day: '{word} · {n}. gün',
    last: '{word} · son gün',
    countdown: '{n} dk kaldı',
    now: '{iftar} vakti',
    tomorrow: 'Yarın',
    eve: '{word} yarın başlıyor',
};
//# sourceMappingURL=golf4App.tr.js.map